export const FEEDBACK_DIALOG_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.FeedbackDialogTemplateInterface.FeedbackDialogTemplate';
